import type { IncidentType } from '@/types';

const isIncidentMatchedByStations = (
  incident: IncidentType,
  selectedStationIds: Set<string>
): boolean => incident.affectedStops?.some((stop) => selectedStationIds.has(stop.id)) ?? false;

export default isIncidentMatchedByStations;
